import { render, staticRenderFns } from "./PaymentDataTable.vue?vue&type=template&id=6762c38e&"
import script from "./PaymentDataTable.vue?vue&type=script&lang=js&"
export * from "./PaymentDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6762c38e')) {
      api.createRecord('6762c38e', component.options)
    } else {
      api.reload('6762c38e', component.options)
    }
    module.hot.accept("./PaymentDataTable.vue?vue&type=template&id=6762c38e&", function () {
      api.rerender('6762c38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Payment/components/PaymentGateway/PaymentDataTable.vue"
export default component.exports